<template>
  <!--<transition name="fade-transform" mode="out-in">-->
  <!--<keep-alive>-->
  <!--<router-view :key="key"/>-->
  <!--</keep-alive>-->
  <!--</transition>-->

  <!--<div>-->
  <!--<transition name="fade-transform" mode="out-in">-->
  <!--<keep-alive>-->
  <!--<router-view v-if="$route.meta.keepAlive" :key="key"/>-->
  <!--</keep-alive>-->
  <!--</transition>-->
  <!--<transition name="fade-transform" mode="out-in">-->
  <!--<router-view v-if="!$route.meta.keepAlive"/>-->
  <!--</transition>-->
  <!--</div>-->

  <transition name="fade-transform" mode="out-in">
    <router-view/>
  </transition>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      key () {
        return this.$route.path
      }
    }
  }
</script>

<style lang="scss" scoped>
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all .28s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }
</style>
